// ink-component
import React, { useContext, useMemo } from 'react';
import { SideNavContext } from '../../SideNavContext';
import getGlobalProps from '../../../../helpers/constants/global-props';
import { StyledSideNavFilter, StyledSideNavFilterWrapper, StyledSideNavFilterKeyboardShortcut } from './styles';

/**
 * @purpose Input field for navigation filtering
 * @group SideNav
 * @categories navigation

 * @HTMLType HTMLInputElement
 */

export type SideNavFilterProps = React.InputHTMLAttributes<HTMLInputElement> & {
  /** Shows platform-native keyboard shortcut (i.e. ⌘K for Mac and Ctrl+K for Windows) */
  showKeyboardShortcut?: boolean;
};

const getKeyboardShortcut = () => {
  if (/Mac/.test(navigator.platform)) {
    return '⌘K';
  }
  return 'Ctrl+K';
};

/**
 * @purpose Input field for navigation filtering
 * @group SideNav
 * @categories navigation
 * @HTMLType HTMLInputElement
 */
const SideNavFilter = (props: SideNavFilterProps) => {
  const { className, style, showKeyboardShortcut = false, ...otherProps } = props;
  const { isClosed } = useContext(SideNavContext);
  const globalProps = getGlobalProps({});
  const keyboardShortcut = useMemo(() => getKeyboardShortcut(), []);

  return (
    <StyledSideNavFilterWrapper>
      {showKeyboardShortcut && (
        <StyledSideNavFilterKeyboardShortcut isClosed={isClosed}>
          {keyboardShortcut}
        </StyledSideNavFilterKeyboardShortcut>
      )}
      <StyledSideNavFilter type="search" isClosed={isClosed} {...otherProps} {...globalProps} />
    </StyledSideNavFilterWrapper>
  );
};

SideNavFilter.displayName = 'SideNav.Filter';

export default SideNavFilter;
